import apiFetch from '../apiFetch'

export default function (idGrupoVerraco, token) {
  return apiFetch({endPoint: `GrupoVerraco/deleteGrupoVerraco`, method: 'POST', body: {idGrupoVerraco}, token: token})
}